import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTheme } from '../ThemeContext';

// ============================================================
// ICONS - SVG Icon Components
// ============================================================

const Icons = {
  Menu: () => (
    <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  ),
  Close: () => (
    <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  Dashboard: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  Calendar: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  Clock: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Document: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  DollarSign: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  User: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Settings: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Plus: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  ),
  Profile: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Logout: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
    </svg>
  ),
  ChevronLeft: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  ),
  ChevronRight: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  ),
  Sun: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  Moon: () => (
    <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
    </svg>
  ),
};

// ============================================================
// ANIMATION VARIANTS
// ============================================================

const sidebarVariants = {
  open: {
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
  closed: {
    x: '-100%',
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
};

const overlayVariants = {
  open: {
    opacity: 1,
    transition: { duration: 0.3 },
  },
  closed: {
    opacity: 0,
    transition: { duration: 0.3 },
  },
};

const contentVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  exit: { 
    opacity: 0, 
    y: -20,
    transition: {
      duration: 0.2,
    },
  },
};

// ============================================================
// THEME TOGGLE BUTTON COMPONENT
// ============================================================

const ThemeToggleButton = ({ isCollapsed, isMobileView }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  
  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle-btn"
      style={{
        justifyContent: isCollapsed && !isMobileView ? 'center' : 'flex-start',
      }}
      title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      <span className="theme-toggle-icon">
        {isDarkMode ? <Icons.Sun /> : <Icons.Moon />}
      </span>
      {(!isCollapsed || isMobileView) && (
        <span style={{ fontWeight: '500', fontSize: '0.875rem' }}>
          {isDarkMode ? 'Light Mode' : 'Dark Mode'}
        </span>
      )}
    </button>
  );
};

// ============================================================
// SIDEBAR COMPONENT
// ============================================================

const Sidebar = ({ 
  menuItems = [], 
  activeTab,
  activeItem, // alias for activeTab
  setActiveTab,
  onItemClick, // alias for setActiveTab
  isOpen, 
  setIsOpen,
  onClose, // alias for setIsOpen(false)
  isMobile,
  isCollapsed,
  setIsCollapsed,
  onToggleCollapse, // alias for setIsCollapsed toggle
  userInfo,
  onLogout,
  logo,
  headerInfo, // { logo, title, subtitle }
  footerButtons = [] // [{ label, icon, onClick, className }]
}) => {
  // Detect PWA mode for safe area handling
  const isPWAMode = typeof window !== 'undefined' && (
    window.matchMedia('(display-mode: standalone)').matches || 
    window.navigator.standalone === true
  );

  // Normalize props - support both naming conventions
  const currentTab = activeTab || activeItem;
  const handleTabChange = setActiveTab || onItemClick || (() => {});
  const handleClose = onClose || (setIsOpen ? () => setIsOpen(false) : () => {});
  const handleToggleCollapse = onToggleCollapse || (setIsCollapsed ? () => setIsCollapsed(!isCollapsed) : () => {});
  // eslint-disable-next-line no-unused-vars
  const displayLogo = headerInfo?.logo || logo;
  // eslint-disable-next-line no-unused-vars
  const headerTitle = headerInfo?.title || 'Dashboard';
  // eslint-disable-next-line no-unused-vars
  const headerSubtitle = headerInfo?.subtitle || 'Preparer Portal';
  
  // Detect mobile from window width if not provided
  const [autoDetectedMobile, setAutoDetectedMobile] = useState(false);
  useEffect(() => {
    if (isMobile === undefined) {
      const checkMobile = () => setAutoDetectedMobile(window.innerWidth < 1024);
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }
  }, [isMobile]);
  const isMobileView = isMobile !== undefined ? isMobile : autoDetectedMobile;

  const handleMenuClick = (tabId) => {
    handleTabChange(tabId);
    if (isMobileView) {
      handleClose();
    }
  };

  // Format menu items - support both flat array and sectioned array
  const normalizedMenuItems = useMemo(() => {
    if (!menuItems || menuItems.length === 0) return [];
    
    // Check if it's already sectioned (has label and items)
    if (menuItems[0]?.items) {
      return menuItems;
    }
    
    // Convert flat array to sectioned format
    const sections = [];
    let currentSection = { label: '', items: [] };
    
    menuItems.forEach(item => {
      if (item.type === 'divider') {
        if (currentSection.items.length > 0) {
          sections.push(currentSection);
        }
        currentSection = { label: item.label || '', items: [] };
      } else {
        const IconComponent = item.icon;
        currentSection.items.push({
          ...item,
          icon: typeof IconComponent === 'function' ? <IconComponent className="w-5 h-5" /> : item.icon
        });
      }
    });
    
    if (currentSection.items.length > 0) {
      sections.push(currentSection);
    }
    
    return sections.length > 0 ? sections : [{ label: '', items: menuItems.map(item => {
      const IconComponent = item.icon;
      return {
        ...item,
        icon: typeof IconComponent === 'function' ? <IconComponent className="w-5 h-5" /> : item.icon
      };
    })}];
  }, [menuItems]);

  return (
    <>
      {/* Mobile Overlay */}
      <AnimatePresence>
        {isMobileView && isOpen && (
          <motion.div
            variants={overlayVariants}
            initial="closed"
            animate="open"
            exit="closed"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              backdropFilter: 'blur(4px)',
              zIndex: 40
            }}
            onClick={handleClose}
          />
        )}
      </AnimatePresence>

      {/* Sidebar */}
      <motion.aside
        variants={isMobileView ? sidebarVariants : {}}
        initial={isMobileView ? 'closed' : { x: 0 }}
        animate={isMobileView ? (isOpen ? 'open' : 'closed') : { x: 0 }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100%',
          zIndex: 50,
          width: isCollapsed && !isMobileView ? '64px' : '220px',
          background: 'linear-gradient(180deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
          boxShadow: '4px 0 20px rgba(0,0,0,0.3)',
          display: 'flex',
          flexDirection: 'column',
          transition: 'width 0.3s ease-in-out',
          ...(isMobileView && isPWAMode ? { paddingTop: 'env(safe-area-inset-top, 0px)' } : {})
        }}
      >
        {/* Sidebar Header - Mobile Close Only */}
        <div 
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px',
            borderBottom: '1px solid rgba(71, 85, 105, 0.5)',
            justifyContent: isMobileView ? 'space-between' : 'center',
            ...(isMobileView && isPWAMode ? { paddingTop: 'max(12px, env(safe-area-inset-top, 12px))' } : {})
          }}
        >
          {/* Collapse Toggle for Desktop */}
          {!isMobileView && (
            <button
              onClick={handleToggleCollapse}
              style={{
                padding: '8px',
                color: '#94a3b8',
                background: 'transparent',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              title={isCollapsed ? 'Expand Menu' : 'Collapse Menu'}
            >
              {isCollapsed ? <Icons.ChevronRight /> : <Icons.ChevronLeft />}
            </button>
          )}
          
          {/* Mobile Close Button */}
          {isMobileView && (
            <>
              <span style={{ color: 'white', fontSize: '0.875rem', fontWeight: '500' }}>Menu</span>
              <button
                onClick={handleClose}
                style={{
                  padding: '8px',
                  color: '#94a3b8',
                  background: 'transparent',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                <Icons.Close />
              </button>
            </>
          )}
        </div>

        {/* Navigation - Scrollable */}
        <nav style={{ 
          flex: 1, 
          padding: '8px', 
          overflowY: 'auto', 
          overflowX: 'hidden',
          scrollbarWidth: 'thin', 
          scrollbarColor: '#475569 transparent' 
        }}>
          {normalizedMenuItems.map((section, sectionIndex) => (
            <div key={sectionIndex} style={{ marginBottom: '16px' }}>
              {/* Section Label */}
              {section.label && (!isCollapsed || isMobileView) && (
                <p style={{
                  padding: '0 12px',
                  marginBottom: '8px',
                  fontSize: '10px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  color: '#64748b'
                }}>
                  {section.label}
                </p>
              )}
              {section.label && isCollapsed && !isMobileView && (
                <div style={{ height: '1px', background: 'rgba(71, 85, 105, 0.5)', margin: '0 8px 12px' }} />
              )}
              
              {/* Menu Items */}
              {section.items.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleMenuClick(item.id)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 12px',
                    marginBottom: '4px',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    position: 'relative',
                    justifyContent: isCollapsed && !isMobileView ? 'center' : 'flex-start',
                    background: currentTab === item.id 
                      ? '#2563eb' 
                      : 'transparent',
                    color: currentTab === item.id ? 'white' : '#94a3b8',
                    boxShadow: currentTab === item.id ? '0 4px 12px rgba(37, 99, 235, 0.4)' : 'none'
                  }}
                >
                  <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                    {item.icon}
                  </span>
                  
                  {(!isCollapsed || isMobileView) && (
                    <span style={{ fontWeight: '500', fontSize: '0.875rem', whiteSpace: 'nowrap' }}>{item.label}</span>
                  )}
                  
                  {/* Badge */}
                  {item.badge !== undefined && (!isCollapsed || isMobileView) && (
                    <span style={{
                      marginLeft: 'auto',
                      padding: '2px 6px',
                      borderRadius: '9999px',
                      fontSize: '10px',
                      fontWeight: '600',
                      background: currentTab === item.id ? 'rgba(255,255,255,0.2)' : 'rgba(37, 99, 235, 0.2)',
                      color: currentTab === item.id ? 'white' : '#60a5fa'
                    }}>
                      {item.badge}
                    </span>
                  )}
                  
                  {/* Collapsed Badge */}
                  {item.badge !== undefined && isCollapsed && !isMobileView && (
                    <span style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-4px',
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      background: '#2563eb',
                      color: 'white',
                      fontSize: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: '600'
                    }}>
                      {item.badge}
                    </span>
                  )}
                </button>
              ))}
            </div>
          ))}
        </nav>

        {/* Footer Actions */}
        <div style={{
          padding: '8px',
          borderTop: '1px solid rgba(71, 85, 105, 0.5)'
        }}>
          {/* Theme Toggle */}
          <ThemeToggleButton isCollapsed={isCollapsed} isMobileView={isMobileView} />
          
          {/* Custom Footer Buttons */}
          {footerButtons.map((btn, idx) => {
            const BtnIcon = btn.icon;
            return (
              <button
                key={idx}
                onClick={btn.onClick}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 12px',
                  borderRadius: '8px',
                  marginBottom: '4px',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  justifyContent: isCollapsed && !isMobileView ? 'center' : 'flex-start',
                  color: '#94a3b8'
                }}
              >
                {BtnIcon && <BtnIcon style={{ width: '16px', height: '16px' }} />}
                {(!isCollapsed || isMobileView) && (
                  <span style={{ fontWeight: '500', fontSize: '0.875rem' }}>{btn.label}</span>
                )}
              </button>
            );
          })}
          
          {/* Default Logout if no footer buttons and onLogout provided */}
          {footerButtons.length === 0 && onLogout && (
            <button
              onClick={onLogout}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 12px',
                borderRadius: '8px',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                transition: 'all 0.2s',
                justifyContent: isCollapsed && !isMobileView ? 'center' : 'flex-start',
                color: '#94a3b8'
              }}
            >
              <Icons.Logout />
              {(!isCollapsed || isMobileView) && (
                <span style={{ fontWeight: '500', fontSize: '0.875rem' }}>Logout</span>
              )}
            </button>
          )}
        </div>
      </motion.aside>
    </>
  );
};

// ============================================================
// MOBILE HEADER COMPONENT
// ============================================================

const MobileHeader = ({ setIsOpen, title, userInfo }) => (
  <header style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 30,
    height: '64px',
    padding: '0 16px',
    background: 'rgba(255,255,255,0.8)',
    backdropFilter: 'blur(12px)',
    borderBottom: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }}>
    <button
      onClick={() => setIsOpen(true)}
      style={{
        padding: '8px',
        marginLeft: '-8px',
        color: '#475569',
        background: 'transparent',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s'
      }}
    >
      <Icons.Menu />
    </button>
    
    <h1 style={{ fontWeight: '600', color: '#0f172a' }}>{title}</h1>
    
    <div style={{
      width: '36px',
      height: '36px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #3b82f6 0%, #9333ea 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {userInfo?.photo ? (
        <img src={userInfo.photo} alt={userInfo.name} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
      ) : (
        <span style={{ color: 'white', fontWeight: '600', fontSize: '0.875rem' }}>
          {userInfo?.name?.charAt(0)?.toUpperCase() || 'U'}
        </span>
      )}
    </div>
  </header>
);

// ============================================================
// MAIN CONTENT WRAPPER COMPONENT
// ============================================================

const MainContent = ({ 
  children, 
  activeTab, 
  isCollapsed,
  isSidebarCollapsed, // alias for isCollapsed
  isMobile,
  onMenuClick, // callback to open mobile menu
  headerTitle,
  headerSubtitle,
  headerActions,
  userInfo, // { name, photo, role }
  companyInfo // { name, logo }
}) => {
  // Normalize props
  const sidebarCollapsed = isCollapsed !== undefined ? isCollapsed : isSidebarCollapsed;
  
  // Auto-detect mobile
  const [autoDetectedMobile, setAutoDetectedMobile] = useState(false);
  useEffect(() => {
    if (isMobile === undefined) {
      const checkMobile = () => setAutoDetectedMobile(window.innerWidth < 1024);
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }
  }, [isMobile]);
  const isMobileView = isMobile !== undefined ? isMobile : autoDetectedMobile;
  
  // Get current date
  const today = new Date();
  const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = today.toLocaleDateString('en-US', dateOptions);

  // Detect PWA mode for safe area handling
  const isPWAMode = typeof window !== 'undefined' && (
    window.matchMedia('(display-mode: standalone)').matches || 
    window.navigator.standalone === true
  );

  return (
    <>
      {/* Mobile Header */}
      {isMobileView && onMenuClick && (
        <header style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 30,
          height: isPWAMode ? 'calc(68px + env(safe-area-inset-top, 0px))' : '68px',
          paddingTop: isPWAMode ? 'max(16px, env(safe-area-inset-top, 16px))' : '0',
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingBottom: '0',
          background: 'var(--header-bg)',
          borderBottom: '1px solid var(--border-primary)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: 'var(--shadow-sm)'
        }}>
          {/* Left - Menu */}
          <button
            onClick={onMenuClick}
            style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--text-secondary)',
              background: 'var(--bg-tertiary)',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer'
            }}
          >
            <Icons.Menu />
          </button>
          
          {/* Center - Company Logo & Name */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px',
            flex: 1,
            justifyContent: 'center'
          }}>
            {companyInfo?.logo && (
              <div style={{
                width: '38px',
                height: '38px',
                borderRadius: '10px',
                background: '#ffffff',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                padding: '3px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img 
                  src={companyInfo.logo} 
                  alt={companyInfo.name || 'Company'} 
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '100%', 
                    objectFit: 'contain',
                    borderRadius: '4px'
                  }} 
                />
              </div>
            )}
            <span style={{ 
              fontSize: '1rem', 
              fontWeight: '600', 
              color: 'var(--text-primary)',
              maxWidth: '150px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {companyInfo?.name || 'Friends Tax Services LLC'}
            </span>
          </div>
          
          {/* Right - User */}
          {userInfo && (
            <div style={{
              width: '42px',
              height: '42px',
              borderRadius: '12px',
              background: userInfo.photo ? '#e5e7eb' : 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}>
              {userInfo.photo ? (
                <img src={userInfo.photo} alt={userInfo.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <span style={{ color: 'white', fontWeight: '600', fontSize: '0.875rem' }}>{userInfo.name?.charAt(0)?.toUpperCase() || 'P'}</span>
              )}
            </div>
          )}
        </header>
      )}

      <main 
        style={{
          minHeight: '100vh',
          backgroundColor: 'var(--bg-secondary)',
          marginLeft: isMobileView ? 0 : (sidebarCollapsed ? '64px' : '220px'),
          paddingTop: isMobileView ? (isPWAMode ? 'calc(68px + env(safe-area-inset-top, 20px))' : '68px') : 0,
          transition: 'margin-left 300ms ease-in-out'
        }}
      >
        {/* Desktop Header */}
        {!isMobileView && (
          <div style={{
            position: 'sticky',
            top: 0,
            zIndex: 20,
            background: 'var(--header-bg)',
            borderBottom: '1px solid var(--border-primary)',
            padding: '16px 32px',
            boxShadow: 'var(--shadow-sm)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              {/* Left - Company Logo & Name */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                {companyInfo?.logo && (
                  <div style={{
                    width: '52px',
                    height: '52px',
                    borderRadius: '14px',
                    background: 'var(--bg-primary)',
                    boxShadow: 'var(--shadow-sm)',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid var(--border-primary)'
                  }}>
                    <img 
                      src={companyInfo.logo} 
                      alt={companyInfo.name || 'Company'} 
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '100%', 
                        objectFit: 'contain',
                        borderRadius: '6px'
                      }} 
                    />
                  </div>
                )}
                <div>
                  <h1 style={{ 
                    margin: 0, 
                    fontSize: '1.4rem', 
                    fontWeight: '700', 
                    color: 'var(--text-primary)',
                    letterSpacing: '-0.025em'
                  }}>
                    {companyInfo?.name || 'TaxFile Pro'}
                  </h1>
                  <p style={{ 
                    margin: 0, 
                    fontSize: '0.85rem', 
                    color: 'var(--text-tertiary)',
                    marginTop: '2px'
                  }}>
                    {formattedDate}
                  </p>
                </div>
              </div>
              
              {/* Right - Actions */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                {headerActions}
                
                {userInfo && (
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '10px',
                    paddingLeft: headerActions ? '16px' : '0',
                    borderLeft: headerActions ? '1px solid var(--border-primary)' : 'none'
                  }}>
                    <span style={{ 
                      fontSize: '0.875rem', 
                      fontWeight: '500', 
                      color: 'var(--text-secondary)' 
                    }}>
                      {userInfo.name}
                    </span>
                    <div style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '10px',
                      background: userInfo.photo ? '#e5e7eb' : 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                    }}>
                      {userInfo.photo ? (
                        <img src={userInfo.photo} alt={userInfo.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <span style={{ color: 'white', fontWeight: '600', fontSize: '0.875rem' }}>{userInfo.name?.charAt(0)?.toUpperCase() || 'P'}</span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        
        <div style={{ padding: isMobileView ? '16px' : '24px' }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              variants={contentVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </div>
      </main>
    </>
  );
};

// ============================================================
// CONTENT CARD COMPONENT
// ============================================================

const ContentCard = ({ children, className = '', noPadding = false }) => (
  <div 
    style={{
      backgroundColor: 'var(--bg-card)',
      borderRadius: '12px',
      border: '1px solid var(--border-primary)',
      padding: noPadding ? '0' : '20px'
    }}
  >
    {children}
  </div>
);

// ============================================================
// STAT CARD COMPONENT
// ============================================================

const StatCard = ({ icon: IconProp, label, title, value, trend, trendUp, color = 'blue', onClick }) => {
  const colors = {
    blue: { main: '#3b82f6', light: '#eff6ff', gradient: 'linear-gradient(135deg, #3b82f6, #2563eb)' },
    green: { main: '#22c55e', light: '#f0fdf4', gradient: 'linear-gradient(135deg, #22c55e, #16a34a)' },
    purple: { main: '#8b5cf6', light: '#f5f3ff', gradient: 'linear-gradient(135deg, #8b5cf6, #7c3aed)' },
    orange: { main: '#f97316', light: '#fff7ed', gradient: 'linear-gradient(135deg, #f97316, #ea580c)' },
  };
  
  const displayLabel = label || title;
  const colorSet = colors[color] || colors.blue;
  
  const renderIcon = () => {
    if (!IconProp) return null;
    if (typeof IconProp === 'function') return <IconProp />;
    return IconProp;
  };

  const handleMouseEnter = (e) => {
    if (onClick) {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
      e.currentTarget.style.borderColor = colorSet.main;
    }
  };

  const handleMouseLeave = (e) => {
    if (onClick) {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.04)';
      e.currentTarget.style.borderColor = 'var(--border-primary)';
    }
  };

  return (
    <div 
      style={{
        backgroundColor: 'var(--bg-card)',
        borderRadius: '10px',
        border: '1px solid var(--border-primary)',
        padding: '10px 12px',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: 'var(--shadow-sm)',
        transition: 'all 0.2s ease',
        cursor: onClick ? 'pointer' : 'default',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div style={{
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: colorSet.gradient,
        color: 'white',
        flexShrink: 0,
        fontSize: '0.9rem'
      }}>
        {renderIcon()}
      </div>
      <div style={{ minWidth: 0 }}>
        <p style={{ 
          fontSize: '1.25rem', 
          fontWeight: '700', 
          color: 'var(--text-primary)', 
          margin: 0, 
          letterSpacing: '-0.02em',
          lineHeight: 1
        }}>{value}</p>
        <p style={{ 
          fontSize: '0.7rem', 
          color: 'var(--text-tertiary)', 
          marginTop: '2px', 
          fontWeight: '500',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>{displayLabel}</p>
      </div>
      {trend && (
        <span style={{
          fontSize: '0.65rem',
          fontWeight: '600',
          color: trendUp ? '#16a34a' : '#dc2626',
          padding: '2px 6px',
          borderRadius: '10px',
          background: trendUp ? '#dcfce7' : '#fef2f2',
          marginLeft: 'auto'
        }}>
          {trendUp ? '↑' : '↓'} {trend}
        </span>
      )}
    </div>
  );
};

// ============================================================
// MAIN SIDEBAR LAYOUT COMPONENT
// ============================================================

const ModernSidebarLayout = ({ 
  menuItems,
  activeTab,
  setActiveTab,
  children,
  userInfo,
  onLogout,
  logo,
  title = 'Dashboard'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile viewport
  const checkMobile = useCallback(() => {
    setIsMobile(window.innerWidth < 1024);
    if (window.innerWidth >= 1024) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [checkMobile]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobile && isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobile, isOpen]);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      {/* Mobile Header */}
      {isMobile && (
        <MobileHeader 
          setIsOpen={setIsOpen} 
          title={title}
          userInfo={userInfo}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        menuItems={menuItems}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isMobile={isMobile}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        userInfo={userInfo}
        onLogout={onLogout}
        logo={logo}
      />

      {/* Main Content */}
      <MainContent 
        activeTab={activeTab} 
        isCollapsed={isCollapsed}
        isMobile={isMobile}
      >
        {children}
      </MainContent>
    </div>
  );
};

// ============================================================
// EXPORTS
// ============================================================

export { 
  ModernSidebarLayout,
  Sidebar,
  MainContent,
  ContentCard, 
  StatCard, 
  Icons 
};

export default ModernSidebarLayout;
